import { type AsideItem } from "../types";
import { Link } from "react-router";

const MenuItem = ({
  pathname,
  asideItems,
  searchable,
}: {
  pathname: string;
  asideItems: AsideItem[];
  searchable?: boolean;
}) => {

  const filteredAsideItems = asideItems.filter(
    (asideItem) =>
      asideItem.href || (!asideItem.href && asideItem.dropdown?.length !== 0),
  );

  return (
    <ul>
      {searchable && asideItems.length > 0 && (
        <li
          children={
            <input
              type="text"
              name="search"
              placeholder="Buscar"
            />
          }
        />
      )}
      {filteredAsideItems.map((asideItem, index) => {
        const isActive = asideItem.href ? pathname.startsWith(asideItem.href) : false;

        return (
          <li
            onClick={asideItem.onClick}
            key={index}
            className={`${asideItem.classname ?? ""} ${isActive ? "--active" : ""} ${asideItem.dropdown ? "--is_dropdown" : ""}`}
            style={{ borderRadius: asideItem.content === "Sair" ? " 0 0 1rem 0" : "" }}
          >
            {asideItem.content === "Gestão Atendimento" ||
              asideItem.content === "NTO - Flow" ||
              asideItem.content === "SLA" ? (
              <Link to={asideItem.href ?? "#"} target="_blank">

                {asideItem.icon && <i>{asideItem.icon}</i>}
                <span>{asideItem.content}</span>
              </Link>
            ) : (
              <Link to={asideItem.href ?? "#"}>
                {asideItem.icon && <i>{asideItem.icon}</i>}
                <span>{asideItem.content}</span>
              </Link>
            )}
            {asideItem.dropdown && (
              <MenuItem
                pathname={pathname}
                asideItems={asideItem.dropdown}
                searchable={asideItem.searchable}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default MenuItem;
